export default __webpack_public_path__ + "static/media/add_circle-fill24px.bbcd5a89.svg";